import { render, staticRenderFns } from "./MovementsHeader.vue?vue&type=template&id=68dcf5fd&scoped=true&"
import script from "./MovementsHeader.vue?vue&type=script&lang=js&"
export * from "./MovementsHeader.vue?vue&type=script&lang=js&"
import style0 from "./MovementsHeader.vue?vue&type=style&index=0&id=68dcf5fd&scoped=true&lang=less&"
import style1 from "./MovementsHeader.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dcf5fd",
  null
  
)

export default component.exports